import { ScreenName, ScreenFlow } from 'lib/types';
import brands from '../brands';

// A simple mapping of which page should be loaded next when you "click" on a page
// the key is the current page, the value is the "next" page
// map: {
			// dashboard: 'dashboard-auth',
			// 'dashboard-auth': 'dashboard2',
			// dashboard2: 'dashboard3',
			// dashboard3: 'dashboard3',
			// home: 'home',
			// matching: 'stewardship',
			// stewardship: 'home'
		// },
const clickFlows: Record<string, ScreenFlow> = {

	// Parker's main stage demo
	df18Brunello: {
		brand: brands.df18Brunello,
		brandName: 'Brunello Cucinelli',
		description: 'Dreamforce 2018 Main Stage keynote for Parker\'s section.',
		showInListing: true,
		
		map: {
			dashboard: 'dashboard-auth1',
			'dashboard-auth1': 'dashboard2', 
			dashboard2: 'dashboard-auth2',
			'dashboard-auth2': 'dashboard3', 
			dashboard3: 'dashboard-auth3',
			'dashboard-auth3': 'dashboard4', 
			dashboard4 : 'dashboard4',
			dashboard4CookingShow : 'dashboard5', 
			dashboard5 : 'dashboard5', 
			home : 'home'
		},
		name: 'Main Stage Keynote',
		navRedirector: (currentScreen, navName) => {
			if (currentScreen === 'matching' && navName === 'home') {
				return 'home';
			}
			return navName as ScreenName;
		},
		start: 'dashboard',
	},

};

export default clickFlows;


// WEBPACK FOOTER //
// ./src/data/click-flows.ts